import CommunicationProgramKeyUserManagementContainer from './CommunicationProgramKeyUserManagementContainer.js';

export default CommunicationProgramKeyUserManagementContainer;